/**
 * Route + hub guards aligned with Naturals Portal org enabled_services.
 * Spread onto workspace / partner / executive permissionService.
 */
import { orgHasService, readStoredOrgEnabledServices, effectiveOrgEnabledServices } from "./orgEnabledServices";

export function orgEntitlementAccessMixin(portalId) {
  return {
    getOrgEnabledServices() {
      return effectiveOrgEnabledServices(readStoredOrgEnabledServices(portalId));
    },

    hasOrgService(key) {
      return orgHasService(this.getOrgEnabledServices(), key);
    },

    canAccessSkinAnalysis() {
      return this.hasOrgService("skin_analysis");
    },

    canAccessHairAnalysis() {
      return this.hasOrgService("hair_analysis");
    },

    canAccessSkinOrHairCatalog() {
      return this.canAccessSkinAnalysis() || this.canAccessHairAnalysis();
    },

    canAccessSkinSettings() {
      if (!this.canAccessSkinAnalysis()) return false;
      if (typeof this.canManageSkinSettings === "function") {
        return this.canManageSkinSettings();
      }
      return true;
    },

    canAccessServiceCatalogAdmin() {
      if (!this.canAccessSkinOrHairCatalog()) return false;
      if (this.isFranchise?.()) return true;
      return typeof this.canManageServices === "function" ? this.canManageServices() : false;
    },

    canAccessProductCatalogAdmin() {
      if (!this.canAccessSkinOrHairCatalog()) return false;
      if (this.isFranchise?.()) return true;
      return typeof this.canManageProducts === "function" ? this.canManageProducts() : false;
    },

    canAccessFlowAnalytics() {
      return (
        this.hasOrgService("hair_style") ||
        this.hasOrgService("hair_coloring")
      );
    },

    canAccessGuestOpsAnalytics() {
      return (
        this.canAccessSkinAnalysis() ||
        this.canAccessHairAnalysis() ||
        this.hasOrgService("customer_engagement") ||
        this.hasOrgService("hair_style") ||
        this.hasOrgService("hair_coloring")
      );
    },

    canAccessSkinAnalytics() {
      return (
        (typeof this.canViewStoreKpis === "function" ? this.canViewStoreKpis() : true) &&
        this.canAccessSkinAnalysis()
      );
    },

    canAccessHairAnalytics() {
      return (
        (typeof this.canViewStoreKpis === "function" ? this.canViewStoreKpis() : true) &&
        this.canAccessHairAnalysis()
      );
    },

    canAccessCustomerEngagement() {
      return this.hasOrgService("customer_engagement");
    },

    canAccessWhatsApp() {
      return this.hasOrgService("whatsapp");
    },

    canAccessReels() {
      return false;
    },

    canAccessKioskSkinStack() {
      return this.canAccessSkinAnalysis();
    },
  };
}
